<template>
    <div class="programa-section">
        <div class="programa-content">
            <h2 class="programa-title fuente-posm">
                Programa de lealtad
            </h2>
            <p class="programa-text fuente-nova">
                Creamos un programa de lealtad personalizado para tu negocio. Tú defines las reglas: qué se premia, cómo se acumulan puntos y qué recompensas reciben tus clientes.
                <br><br>
                Ellos solo escanean el código QR de su ticket y comienzan a interactuar desde WhatsApp. Sin apps, sin complicaciones. Todo bajo tu marca, con una experiencia que realmente conecta.
            </p>
        </div>
        <div class="programa-image">
            <img :src="a67" alt="Programa de Lealtad">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgramaLealtadRewardNew',
    data() {
        return {
            a67: require('@/assets/images/a67.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.programa-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.programa-content {
    flex: 1;
    max-width: 600px;
    order: 1;
}

.programa-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.programa-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.programa-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.programa-image img {
    width: 50%;
    max-width: 300px;
    height: auto;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .programa-title {
        font-size: 60px;
    }

    .programa-text {
        font-size: 27px;
    }

    .programa-image img {
        max-width: 250px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .programa-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .programa-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .programa-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .programa-image img {
        width: 60%;
        max-width: 200px;
    }

    .programa-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .programa-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
